import DataRequest from'@shopgate/pwa-core/classes/DataRequest';import setDebugLoggingEnabled from'@shopgate/pwa-core/commands/setDebugLoggingEnabled';/**
 * Enable debug logging.
 * @return {Function} A redux thunk.
 */export var enableDebugLogging=function enableDebugLogging(){return function(){setDebugLoggingEnabled();new DataRequest('ajax_started_live_logging').dispatch();};};